import React, { lazy, Suspense } from 'react'
import { Route, Switch } from "react-router-dom";
import { useSelector } from "react-redux";

import NavbarMenu from "../components/NavbarMenu";
import Loader from "../components/ui/loader";
import OfficerShell, { isOfficer } from "../components/officerShell";
import { OfficerAccessProvider, gated, SECTIONS } from "../components/officerShell/access";
import SchoolReport from "../screens/officer/SchoolReport";
import VcReport from '../screens/officer/vcReport';
import VcReportAdmin from '../screens/VcReportAdmin';
import SchoolVcAdmin from '../screens/schollVcAdmin';

const Login = lazy(() => import("../screens/Login"));
const Logout = lazy(() => import("../screens/Auth/Logout"));
// import registration from "../screens/Auth/Registration";
// import lockscreen from "../screens/Auth/Lockscreen";
// import forgotpassword from "../screens/Auth/ForgotPassword";
// import page404 from "../screens/Auth/Page404";
// import page403 from "../screens/Auth/Page403";
// import page500 from "../screens/Auth/Page500";
// import page503 from "../screens/Auth/Page503";

// import MyTable from "../screens/Dashbord/MyTable";
// import MyForm from "../screens/Dashbord/MyForm"
const AddComplain = lazy(() => import("../screens/AddComplain"));
const ViewComplain = lazy(() => import("../screens/ViewComplain"));
const ViewSchool = lazy(() => import("../screens/ViewSchool"));
const ActionLog = lazy(() => import('../screens/ActionLog'));
const CreateAccount = lazy(() => import('../screens/CreateAccount'));
const UserList = lazy(() => import('../screens/UserList'));
const SectionAccess = lazy(() => import('../screens/SectionAccess'));
const Settings = lazy(() => import('../screens/Settings'));
const Dashboard = lazy(() => import('../screens/Dashbord'));

//BEo _DEO
const BEODash = lazy(() => import('../screens/officer/dashboard'));
const BEOComplain = lazy(() => import('../screens/officer/complain'));
const BEOComplainInfo = lazy(() => import('../screens/officer/complainInfo'));
const BEOActionLog = lazy(() => import('../screens/officer/actionLog'));
const BEOAuth = lazy(() => import('../screens/officer/auth'));
const Reports = lazy(() => import('../screens/Report'));
const PendencyReport = lazy(() => import('../screens/pendencyReport'));
const PendencyReportCat = lazy(() => import('../screens/pendencyReportCategory'));
const PendencyReportCount = lazy(() => import('../screens/pendencyReport/singleView'));
const PendencyReportOfficer = lazy(() => import('../screens/officer/pendencyReportOfficer'));
const PendencyReportOfficerCount = lazy(() => import('../screens/officer/pendencyReportOfficer/singleView'));
const SchoolVCData = lazy(() => import('../screens/officer/schoolVCData'));

// Officer sections an admin can switch off; the gate shows "no access" instead.
const GatedSchoolVCData = gated(SchoolVCData, SECTIONS.SCHOOL_VC_REPORT);
const GatedSchoolReport = gated(SchoolReport, SECTIONS.SCHOOL_UPLOAD);
const GatedVcReport = gated(VcReport, SECTIONS.VC_UPLOAD);
const GatedPendencyReportCat = gated(PendencyReportCat, SECTIONS.CATEGORY_REPORT);
const GatedPendencyReportCount = gated(PendencyReportCount, SECTIONS.CATEGORY_REPORT);

const RouteData = (props) => {
    var res = window.location.pathname;
    var baseUrl = process.env.PUBLIC_URL;
    baseUrl = baseUrl.split("/");
    res = res.split("/");
    res = res.length > 0 ? res[baseUrl.length] : "/";
    res = res ? res : "/";
    const activeKey1 = res;
    // SSO officers get their own shell (top bar + section nav with Home);
    // call-centre staff keep the sidebar layout.
    const auth = useSelector((state) => state.Auth?.auth);
    const officer = isOfficer(auth);
    return (
        <div>
            <Suspense fallback={<Loader />}>
                {!props.token ? (
                    <Switch>
                        {/* <Route exact path={`${process.env.PUBLIC_URL}`} component={Login} /> */}
                        <Route
                            exact
                            path={`/`}
                            component={Login}
                        />
                        <Route
                            exact
                            path={`/login`}
                            component={Login}
                        />
                        <Route
                            exact
                            path={`/sso/auth/:token`}
                            component={BEOAuth}
                        />

                        <Route
                            exact
                            path={`/pendency`}
                            component={PendencyReport}
                        />
                        <Route
                            exact
                            path={`/pendency-category`}
                            component={PendencyReportCat}
                        />
                        {/* <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/forgotpassword`}
                        component={forgotpassword}
                    />
                    <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/page404`}
                        component={page404}
                    />
                    <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/page403`}
                        component={page403}
                    />
                    <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/page500`}
                        component={page500}
                    />
                    <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/page503`}
                        component={page503}
                    />
                    <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/registration`}
                        component={registration}
                    />
                    <Route exact path={`registration`} component={registration} />
                    <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/lockscreen`}
                        component={lockscreen}
                    />
                    <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/maintanance`}
                        component={maintanance}
                    /> */}
                    </Switch>
                ) : (
                    <OfficerAccessProvider enabled={officer}>
                        {officer ? (
                            <OfficerShell />
                        ) : (
                            <NavbarMenu history={props.history} activeKey={activeKey1} />
                        )}
                        <div id="main-content">
                            <Switch>
                                <Route
                                    exact
                                    path={`/`}
                                    component={Dashboard}
                                />
                                <Route
                                    exact
                                    path={`/add-complain`}
                                    component={AddComplain}
                                />
                                <Route
                                    exact
                                    path={`/view-complain`}
                                    component={ViewComplain}
                                />
                                <Route
                                    exact
                                    path={`/view-school`}
                                    component={ViewSchool}
                                />
                                <Route
                                    exact
                                    path={`/view-vc-report`}
                                    component={VcReportAdmin}
                                />
                                <Route
                                    exact
                                    path={`/school-vc-report`}
                                    component={SchoolVcAdmin}
                                />
                                <Route
                                    exact
                                    path={`/create-account`}
                                    component={CreateAccount}
                                />
                                <Route
                                    exact
                                    path={`/user-list`}
                                    component={UserList}
                                />
                                <Route
                                    exact
                                    path={`/section-access`}
                                    component={SectionAccess}
                                />
                                <Route
                                    exact
                                    path={`/settings`}
                                    component={Settings}
                                />
                                <Route
                                    exact
                                    path={`/logout`}
                                    component={Logout}
                                />
                                <Route
                                    exact
                                    path={`/action-log/:id`}
                                    component={ActionLog}
                                />
                                <Route
                                    exact
                                    path={`/reports`}
                                    component={Reports}
                                />
                                <Route
                                    exact
                                    path={`/officer/dash`}
                                    component={BEODash}
                                />
                                <Route
                                    exact
                                    path={`/officer/complain/:status`}
                                    component={BEOComplain}
                                />
                                <Route
                                    exact
                                    path={`/officer/complainInfo/:id/:status`}
                                    component={BEOComplainInfo}
                                />
                                <Route
                                    exact
                                    path={`/officer/actionLog/:id/:status`}
                                    component={BEOActionLog}
                                />
                                <Route
                                    exact
                                    path={`/sso/auth/:token`}
                                    component={BEOAuth}
                                />
                                <Route
                                    exact
                                    path={`/pendency`}
                                    component={PendencyReport}
                                />
                                <Route
                                    exact
                                    path={`/pendency-category`}
                                    component={GatedPendencyReportCat}
                                />
                                <Route
                                    exact
                                    path={`/pendency-officer`}
                                    component={PendencyReportOfficer}
                                />
                                <Route
                                    exact
                                    path={`/pendency-officer-view`}
                                    component={PendencyReportOfficerCount}
                                />
                                <Route
                                    exact
                                    path={`/pendency-view`}
                                    component={GatedPendencyReportCount}
                                />
                                <Route
                                    exact
                                    path={`/school-report`}
                                    component={GatedSchoolReport}
                                />
                                <Route
                                    exact
                                    path={`/vc-report`}
                                    component={GatedVcReport}
                                />
                                <Route
                                    exact
                                    path={`/officer/school-vc-data/:id/:type/:name`}
                                    component={GatedSchoolVCData}
                                />
                                <Route
                                    exact
                                    path={`/officer/school-vc-data/:id/:type`}
                                    component={GatedSchoolVCData}
                                />
                                <Route
                                    exact
                                    path={`/pendency-category`}
                                    component={GatedPendencyReportCat}
                                />


                            </Switch>
                        </div>
                    </OfficerAccessProvider>
                )}
            </Suspense>
        </div>
    )
}

export default RouteData;